import { AlertCircle } from 'lucide-react';

const POLICIES = [
  { key: 'sig_contract', label: 'Employment Contract', desc: 'I confirm I have received and read my employment contract and agree to its terms.' },
  { key: 'sig_drug', label: 'Drug & Alcohol Policy', desc: 'I understand and agree to The Rattlebone\'s drug and alcohol policy.' },
  { key: 'sig_refusal', label: 'Refusal Policy', desc: 'I have read the Challenge 25 and refusal of service policy.' },
  { key: 'sig_data', label: 'Data Protection Policy', desc: 'I consent to my personal data being processed for employment purposes in accordance with GDPR.' },
  { key: 'sig_optout', label: 'Working Time Opt-Out (if applicable)', desc: 'I understand I may opt out of the 48-hour working week limit. This is voluntary and I may withdraw consent with 7 days\' notice.' },
  { key: 'sig_handbook', label: 'Employee Handbook', desc: 'I confirm I have been provided access to the Employee Handbook and have read its contents.' },
  { key: 'sig_hs', label: 'Health & Safety Declaration', desc: 'I understand my responsibilities under health and safety legislation and The Rattlebone\'s H&S policy.' },
];

interface Props { formData: Record<string, string>; onUpdate: (key: string, val: string) => void; }

export default function Step7Policies({ formData, onUpdate }: Props) {
  const allSigned = POLICIES.every(p => formData[p.key] === 'true');

  return (
    <div className="space-y-3">
      {!allSigned && (
        <div className="flex items-start gap-2 bg-amber-500/10 border border-amber-500/20 rounded-lg px-4 py-3 text-xs text-amber-400 mb-2">
          <AlertCircle className="w-4 h-4 shrink-0 mt-0.5" />
          <span>Please read and acknowledge all policies below before submitting your onboarding form.</span>
        </div>
      )}

      {POLICIES.map(policy => (
        <label key={policy.key} className={`flex items-start gap-3 border rounded-lg p-4 cursor-pointer transition-colors ${formData[policy.key] === 'true' ? 'border-green-500/30 bg-green-500/5' : 'border-border hover:border-primary/30'}`}>
          <input
            type="checkbox"
            checked={formData[policy.key] === 'true'}
            onChange={e => onUpdate(policy.key, e.target.checked ? 'true' : 'false')}
            className="accent-primary mt-0.5 shrink-0 w-4 h-4"
          />
          <div>
            <p className="text-sm font-medium text-foreground">{policy.label}</p>
            <p className="text-xs text-muted-foreground mt-0.5">{policy.desc}</p>
          </div>
        </label>
      ))}

      <div className="border border-primary/30 bg-primary/5 rounded-lg p-4 mt-4">
        <p className="text-xs font-semibold text-foreground mb-1">Employee Declaration</p>
        <p className="text-xs text-muted-foreground">
          By submitting this form, I confirm that the information provided is true and accurate to the best of my knowledge. I understand that providing false or misleading information may affect my employment at The Rattlebone.
        </p>
        <p className="text-xs text-muted-foreground mt-2">
          Submitted on: {new Date().toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' })}
        </p>
      </div>
    </div>
  );
}
